import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, Building2, ShieldCheck, UserPlus } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../services/api';

const initialForm = {
  // Admin account
  name: '',
  email: '',
  password: '',
  confirmPassword: '',
  phone: '',
  // Company
  company_name: '',
  legal_name: '',
  gstin: '',
  pan: '',
  registration_no: '',
  address: '',
  city: '',
  state: '',
  pincode: '',
  country: 'India',
  company_phone: '',
  company_email: '',
  website: '',
  financial_year_start: '04-01',
  currency: 'INR',
};

export default function Register() {
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.company_name.trim()) return toast.error('Company name is required');
    if (form.password !== form.confirmPassword) return toast.error('Passwords do not match');
    if (form.password.length < 6) return toast.error('Password must be at least 6 characters');

    setLoading(true);
    try {
      const payload = { ...form };
      delete payload.confirmPassword;
      const { data } = await api.post('/auth/register', payload);
      if (data.success) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        toast.success(data.message || 'Registered successfully');
        setTimeout(() => nav('/'), 800);
      } else {
        toast.error(data.message || 'Registration failed');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="register-card" onSubmit={submit}>
        <div className="register-head">
          <div className="register-badge" aria-hidden="true">
            <UserPlus size={18} />
          </div>
          <div className="register-head-text">
            <h1>Create Admin Account</h1>
            <p className="subtitle">Enter all details below to finish registration.</p>
          </div>
          <div className="register-pill">
            <ShieldCheck size={14} /> Secure setup
          </div>
        </div>

        <div className="register-grid">
          <div className="register-section">
            <div className="register-section-title">
              <ShieldCheck size={16} /> Your account
            </div>
            <div className="register-form-grid register-form-grid-account">
              <div className="form-group">
                <label>Full name *</label>
                <input value={form.name} onChange={set('name')} required autoFocus />
              </div>
              <div className="form-group">
                <label>Email *</label>
                <input type="email" value={form.email} onChange={set('email')} required />
              </div>
              <div className="form-group">
                <label>Phone</label>
                <input type="tel" value={form.phone} onChange={set('phone')} />
              </div>
              <div className="form-group">
                <label>Password *</label>
                <input type="password" value={form.password} onChange={set('password')} required minLength={6} />
              </div>
              <div className="form-group">
                <label>Confirm password *</label>
                <input type="password" value={form.confirmPassword} onChange={set('confirmPassword')} required />
              </div>
            </div>
          </div>

          <div className="register-section">
            <div className="register-section-title">
              <Building2 size={16} /> Company details
            </div>
            <div className="register-form-grid register-form-grid-company">
              <div className="form-group register-col-2">
                <label>Company name *</label>
                <input value={form.company_name} onChange={set('company_name')} required placeholder="e.g. Alpha Traders Pvt Ltd" />
              </div>
              <div className="form-group">
                <label>Legal name</label>
                <input value={form.legal_name} onChange={set('legal_name')} />
              </div>
              <div className="form-group">
                <label>Registration no.</label>
                <input value={form.registration_no} onChange={set('registration_no')} />
              </div>
              <div className="form-group">
                <label>GSTIN</label>
                <input value={form.gstin} onChange={set('gstin')} placeholder="36AAAAA0000A1Z5" />
              </div>
              <div className="form-group">
                <label>PAN</label>
                <input value={form.pan} onChange={set('pan')} />
              </div>
              <div className="form-group register-col-2">
                <label>Address</label>
                <input value={form.address} onChange={set('address')} placeholder="Street, building, area" />
              </div>
              <div className="form-group">
                <label>City</label>
                <input value={form.city} onChange={set('city')} />
              </div>
              <div className="form-group">
                <label>State</label>
                <input value={form.state} onChange={set('state')} />
              </div>
              <div className="form-group">
                <label>Pincode</label>
                <input value={form.pincode} onChange={set('pincode')} />
              </div>
              <div className="form-group">
                <label>Country</label>
                <input value={form.country} onChange={set('country')} />
              </div>
              <div className="form-group">
                <label>Company phone</label>
                <input value={form.company_phone} onChange={set('company_phone')} />
              </div>
              <div className="form-group">
                <label>Company email</label>
                <input type="email" value={form.company_email} onChange={set('company_email')} />
              </div>
              <div className="form-group register-col-2">
                <label>Website</label>
                <input value={form.website} onChange={set('website')} placeholder="https://example.com" />
              </div>
            </div>
          </div>
        </div>

        <div className="register-actions">
          <button type="submit" className="btn btn-green register-submit" disabled={loading}>
            {loading ? 'Creating account...' : 'Create admin account'} {!loading && <ArrowRight size={16} />}
          </button>
          <div className="register-footer">
            Already have an account? <Link to="/login">Sign in</Link>
          </div>
          <div className="register-muted">© 2026 Noris Solutions</div>
        </div>
      </form>
    </div>
  );
}

